module.exports = __webpack_public_path__ + "static/remove_access_confirmation-f9cb5f5b7beea72b1cced256c9a2c765.png";